import React from "react";
import Alert from "react-bootstrap/Alert";

export const GLOBALS = {
  activeAffiliation: "VIGEN",
  footerImage: "https://www.tbfsistemas.com/wp-content/uploads/2023/08/tbf_trans-541x400.png",
  defaultColor: "#f8d720",
  defaultEmail: "soporte@cibercolegios.com"
}

export const MESSAGES = {
  "OLVIDO_CONTRASENIA": "Si ha olvidado alguno de sus datos de acceso por favor ingrese a continuación la dirección de correo electrónico registrada en el sistema, para enviarle via correo electrónico su acceso.",
  "CIB-GEN-0017": "Apreciado usuario, este portal es exclusivo para servicios de educación. Actualmente no se encuentra registrado en ninguna de nuestras instituciones educativas.",
  "CIB-GEN-0022": "Su sesión ha expirado",
  "CIB-GEN-0002": "Los datos ingresados o contraseña son incorrectos: En caso de haberlos olvidado, comuníquese con el administrador del sistema de su institución",
  "CIB-GEN-0023": "Su afiliación no está vigente",
  "CIB-GEN-0024": "No tiene beneficiarios disponibles",
  "CIB-GEN-0025": "No cumple con la edad requerida para el grado seleccionado",
  "CIB-GEN-0026": "El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado, por favor seleccione otra institución",
  "CIB-GEN-0027": "Ha ocurrido un error inesperado por favor comuníquese con el administrador del sistema",
  "CIB-GEN-0028": "Estimado Padre de Familia, le informamos que en este momento no se encuentra habilitado ningún proceso de inscripción, si usted presenta alguna inquietud le agradecemos comunicarse a la línea 7457900 en Bogotá o línea Nacional 018000 94 7900 de Lunes a Sábado de 07:00 a.m. a 07:00 p.m., en donde le podrán ayudar al respecto.",
  "CIB-GEN-0044": "El grado seleccionado no tiene cupos disponibles",
  "ANY": "Error Desconocido Por favor consulte al administrador para tener más contexto del error",
  "SUCCESS": "Hemos enviado la información a la institución para que se pueda verificar el caso",
  "CIB-GEN-6665": "Problema recuperando su password, contáctese con el administrador",
  "CIB-GEN-0030":"El aspirante no puede ser inscrito, ya que se encuentra registrado como aspirante o estudiante en la institución",
  "CIB-GEN-0031":"El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado",
  "VIGEN": "(Afiliación Vigente)",
  "RETIR": "(Afiliación Retirado)",
  "WELCOME_MESSAGE": "Bienvenido al proceso de inscripción del colegio, tenga presente que la información registrada le permite inscribir a su hijo como aspirante dentro del proceso de admisión, si tiene alguna inquietud comuníquese con el colegio al correo:",
  "NOTE": "NOTA IMPORTANTE: El proceso de matrícula se realiza únicamente en el colegio y grado que usted seleccione, no es posible realizar cambios durante el proceso de matrícula ni una vez finalizado el proceso."
};

class CiberAlerts extends React.Component {
  render() {
    let code = '';
    let message = '';
    if (this.props.code) {
      code = this.props.code
      message = MESSAGES[code]
    } else {
      try {
        code = this.props.error.graphQLErrors[0].extensions.code;
        message = MESSAGES[code];
      } catch (e) {
        try {
          code = this.props.error.networkError.result.message;
          message = MESSAGES[code];
        } catch (e) {
          code = "ANY";
          message = MESSAGES["ANY"]
        }
      }
    }
    
    // Usar variables CSS para los colores, igual que en ModalConfirmEmail
    const alertBg = 'var(--alert-bg)';
    const alertText = 'var(--alert-text)';
    const alertBorder = 'var(--alert-border)';
    const detailBg = 'var(--alert-detail-bg)';
    const detailText = 'var(--alert-detail-text)';
    const infoBg = 'var(--alert-info-bg)';
    const infoText = 'var(--alert-info-text)';
    const infoBorder = 'var(--alert-info-border)';

    return (
      <Alert
        variant="danger"
        style={{
          border: `1px solid ${alertBorder}`,
          borderRadius: "12px",
          padding: "1.5rem",
          marginBottom: "2rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.08)",
          background: alertBg,
          color: alertText,
          textAlign: "left"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem", textAlign: "left" }}>
          <div style={{
            backgroundColor: "#c53030",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "1rem"
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <Alert.Heading style={{
            color: "#c53030",
            fontSize: "1.5rem",
            fontWeight: "600",
            margin: 0,
            textAlign: "left"
          }}>
            ¡La solicitud no ha podido procesarse!
          </Alert.Heading>
        </div>

        <div style={{
          borderRadius: "8px",
          padding: "1rem",
          marginBottom: "1rem",
          border: `1px solid ${alertBorder}`,
          background: alertBg,
          color: alertText,
          textAlign: "left"
        }}>
          <h5 style={{
            fontSize: "1.1rem",
            fontWeight: "500",
            marginBottom: "0.75rem",
            color: alertText,
            textAlign: "left"
          }}>
            El aspirante no puede ser inscrito en el grado seleccionado, por la siguiente razón:
          </h5>
          <div style={{
            fontSize: "1rem",
            padding: "0.75rem",
            borderRadius: "6px",
            borderLeft: "4px solid #f56565",
            background: detailBg,
            color: detailText,
            textAlign: "left"
          }}>
            {message}
          </div>
        </div>

        {/* Mensaje informativo */}
        <div
          style={{
            borderRadius: "8px",
            padding: "1rem",
            border: `1px solid ${infoBorder}`,
            background: infoBg,
            color: infoText,
            marginTop: "8px",
            textAlign: "left"
          }}
        >
          <h5 style={{
            fontSize: "1.1rem",
            fontWeight: "500",
            margin: 0,
            color: infoText,
            textAlign: "left"
          }}>
            Un mensaje fue enviado al colegio con la información de la pre inscripción, para validar el caso presentado.
          </h5>
        </div>
      </Alert>
    )
  }
}

export default CiberAlerts;

